


<!--
  ============================== MÉTODO DE USO ==============================

  <app-paginacion
    *ngIf="comisionesFiltradas.length > 0"
    [totalRegistros]="comisionesFiltradas.length"
    [elementosPorPagina]="elementosPorPaginaComisiones"
    [opcionesElementosPorPagina]="opcionesElementosPorPagina"
    [(paginaActual)]="paginaActualComisiones"
    (paginaCambiada)="onPaginaComisionesCambiada($event)">
  </app-paginacion>

   
   OJITOOOO:
  - "paginaActual" (dentro de los corchetes) 
    es fijo, NO se cambia, es el nombre del Input/Output del componente.
  - "paginaActualComisiones" (a la derecha)  puede llamarse como quieran, pero debe coincidir con la variable que agreguen en el .ts del padre.

  EN EL .TS DEL PADRE VAN A TENER ORIGINALMENTE ALGO ASÍ:

    onPaginaComisionesCambiada(evento: PaginaEvent): void {
    }

  >>>>> SE LE AGREGA ESTA LÍNEA (con el nombre que hayan usado arriba):

    paginaActualComisiones = 1;   <---- nueva variable
    onPaginaComisionesCambiada(evento: PaginaEvent): void {
    }
-->



<section class="table-footer">
  <!-- =========================== -->
  <!-- SELECTOR "MOSTRAR X REGISTROS"-->
  <!-- SIEMPRE visible, sin importar cuántas páginas haya -->
  <!-- =========================== -->
  <div class="rows-selector" *ngIf="mostrarSelectorElementos">
    <span>Mostrar</span>

    <div class="custom-dropdown" [class.open]="dropdownAbierto">
      <button type="button" class="dropdown-trigger" (click)="toggleDropdown()">
        {{ elementosPorPagina }}
        <span class="material-icons">expand_more</span>
      </button>

      <ul class="dropdown-list" *ngIf="dropdownAbierto">
        <li *ngFor="let opcion of opcionesElementosPorPagina" class="dropdown-item"
          [class.active]="opcion === elementosPorPagina" (click)="seleccionarElementosPorPagina(opcion)">
          {{ opcion }}
        </li>
      </ul>
    </div>

    <span>registros</span>
  </div>


  <!-- ===================================================== -->
  <!-- BOTONES DE PÁGINA: Anterior, números, Siguiente -->
  <!-- Solo se muestra si hay más de 1 página -->
  <!-- ===================================================== -->
<div class="pagination" *ngIf="totalPaginas > 1">
  <button class="page-btn page-btn-text btn-anterior" (click)="anterior()" [disabled]="paginaActual === 1">
    <span class="material-icons">chevron_left</span>
    <span class="btn-text">Anterior</span>
  </button>

  <ng-container *ngFor="let pagina of paginas">
    <span *ngIf="pagina === '...'" class="page-ellipsis">...</span>
    <button *ngIf="pagina !== '...'" class="page-number" [class.active]="pagina === paginaActual"
      (click)="irPagina(pagina)">
      {{ pagina }}
    </button>
  </ng-container>

  <button class="page-btn page-btn-text btn-siguiente" (click)="siguiente()" [disabled]="paginaActual === totalPaginas">
    <span class="btn-text">Siguiente</span>
    <span class="material-icons">chevron_right</span>
  </button>
</div>
  <!-- =========================== -->
  <!-- INFO "MOSTRANDO 1 - 5 DE 50 REGISTROS" -->
  <!-- =========================== -->
 <div class="paginacion-info">
  Mostrando
  <strong>{{ inicioRegistro }}</strong>
  -
  <strong>{{ finRegistro }}</strong>
  de
  <strong>{{ totalRegistros }}</strong>
  registros
</div>

</section>